import Input from 'antd/lib/input';
import styled from 'styled-components';

export const SInputGroup = styled(Input.Group)`
  display: flex;
  align-items: flex-start;
`;
